
import { map } from 'rxjs/operators';
import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { IUserDetails } from '../../shared/models/UserDetailsOutputModel';
import { IUserInput } from '../../shared/models/UserInputModel';
import { IUserCreationResponseModel } from '../../shared/models/UserCreationResponseModel';
import { RestService } from '../../shared/providers/rest.service';
import { IPropertyAccessInputModel } from '../../shared/models/PropertyAccessInputModel';
import { ResultOutputModel } from '../../shared/models/resultOutputModel';
import { IuserCountYearly, IuserCountMonthly, IuserCountWeekly } from '../models/UserCountYearly';
import { IDateTimeModel } from '../models/ExchangePropertyStatusInputModel';
import * as internal from 'stream';
import { IInterestCriteriaInputModel } from '../models/InterestCriteriaInputModel';
import { IRequestDemo } from '../models/RequestDemo';
import { IResponseModel } from '../models/ResponseModel';
import { IStandardUserProperties } from '../models/StandardUserProperties';
import { User } from '@auth0/auth0-angular';
import { DataTablesResponse } from '../models/datatables-response';
import { IProspectUserListModel } from '../models/ProspectUserListModel';
import { IForgotPassword } from '../models/forgotpasswordInput';
import { OTPResponseModel } from '../models/OTPResponseModel';
import { SaveNotificationModel } from '../models/SaveNotificationModel';

@Injectable()
export class UserManagerService extends RestService {

  userDetailsResponse = {} as IUserDetails;
  userCreationResponseModel = {} as IUserCreationResponseModel;
  responseModel = {} as IResponseModel;
  standardUserProperties = {} as DataTablesResponse;
  prospectDetails = {} as IProspectUserListModel;
  otpResponseModel = {} as OTPResponseModel;

  // Get the list of properties
  getUserDetails(userGuid: string) {

    let url = "user/details/" + userGuid;
    return this.postForEntityObject<IUserDetails>(url, "").pipe(
      map(response => {
        this.userDetailsResponse = response;
        return this.userDetailsResponse;
      }));
  }

  getProspectUserDetails(userId: string) {

    let url = "user/prospectDetails/" + userId;
    return this.postForEntityObject<IProspectUserListModel>(url, "").pipe(
      map(response => {
        this.prospectDetails = response;
        return response;
      }));
  }


  // create new user
  createUser(iUserInput: IUserInput) {

    let url = "/user/create/";
    return this.postForEntityObject<IUserCreationResponseModel>(url, iUserInput).pipe(
      map(response => {
        this.userCreationResponseModel = response;
        return this.userCreationResponseModel;
      }));
  }

  // update user
  updateUser(iUserInput: IUserInput) {
    let url = "/user/update/";
    return this.postForEntityObject<IUserCreationResponseModel>(url, iUserInput).pipe(
      map(response => {
        this.userCreationResponseModel = response;
        return this.userCreationResponseModel;
      }));
  }

  // Delete User
  deleteUser(userId: number, loggedInUserId: number) {
    let url = "user/delete/" + userId + "/" + loggedInUserId;
    return this.post(url, '');
  }

  // Update 1031 Access
  //shareAuthenticationCode(input: IForgotPassword) {
  //  return this.postForEntityObject<boolean>("user/shareAuthenticationCode", input);
  //}

  checkOTPEnabled(input: IForgotPassword) {
    return this.postForEntityObject<OTPResponseModel>("user/checkOTPEnabled", input).pipe(
      map(response => {
        this.otpResponseModel = response;
        return this.otpResponseModel;
      }));
  }

  saveOTPVerification(input: IForgotPassword) {
    return this.postForEntityObject<string>("user/saveOTPVerification", input).pipe(
      map(response => {
        return response;
      }));
  }

  // Update 1031 Access
  update1031access(input: IPropertyAccessInputModel) {
    return this.postForEntityObject<boolean>("user/update1031access", input);
  }
  Change1031DashboardAccess(userGuid: string, status: boolean, id: number) {
    return this.GET('user/Change1031DashboardAccess/' + userGuid + "/" + status + "/" + id);
  }
  ChangeSellerDashboardAccess(userGuid: string, status: boolean) {
    return this.GET('user/ChangeSellerDashboardAccess/' + userGuid + "/" + status);
  }
  ChangeMyPortfolioAccess(userGuid: string, source: string, status: boolean) {
    return this.GET('user/ChangeMyPortfolioAccess/' + userGuid + "/" + source + "/" + status);
  }
  InviteGuestUser(userId: number, loggedInUser: number) {
    return this.GET('user/inviteuser/' + userId + "/" + loggedInUser);
  }

  GetAllPermissions() {
    return this.GET('user/rolePermissions/');
  }

  // Method to change user role of principal to principal+1031
  ChangeUserRoles(principalUserId: number) {
    return this.postForEntityObject<boolean>("user/ChangeUserRoles/" + principalUserId, '');
  }

  saveEmailNotifications(input: SaveNotificationModel) {
    return this.postForEntityObject<boolean>('user/SaveEmailNotification/', input);
  }

  // Method to change user role of principal to principal+1031
  GetUserByRole(roleId: number) {
    return this.GET("user/GetUserByRole/" + roleId);
  }

  // Method to get the brokerages of user
  getBrokerages(userId: number) {
    return this.GET("user/getBrokerages/" + userId);
  }

  // Method to get the brokerages of user
  getPropertiesByStatus(statusId: number, userId: number, brokerageId: number) {
    return this.GET("user/getPropertiesByStatus/" + statusId + "/" + userId + "/" + brokerageId);
  }

  // Method to get the brokerages of user
  getPropertiesCountByBrokerage(userId: number, brokerageId: number) {
    return this.GET("user/getPropertiesCountByBrokerage/" + userId + "/" + brokerageId);
  }

  GeAllNotificationList(propertyId: number, userId: number) {
    return this.GET("user/notificationList/" + propertyId + "/" + userId);
  }

  //Delete image
  deleteImage(id: number) {
    return this.post('user/deleteImage/' + id, '');
  }

  //Check for active brokers
  checkIsActiveBroker(userId: number) {
    return this.GET('user/CheckIsActiveBroker/' + userId);
  }
  //Check Broker License Used
  CheckBrokerLicenseUsed(licenseId: number) {
    return this.GET('user/CheckBrokerLicenseUsed/' + licenseId);
  }

  GetUserCount(roleId?: number, userId?: number) {
    return this.GET("user/UserCount/" + roleId + "/" + userId);
  }

  GetInvitedUsersCount(userId: number) {
    return this.GET("user/InvitedUsers/" + userId);
  }

  GetUserPermissions(userId: number) {
    return this.GET("user/UserPermissions/" + userId);
  }

  GetOMFilePath(propertyId: number): Observable<string> {
    return this.get("property/OMFilePath/" + propertyId);
  }
  GetPermissionsList() {
    return this.GET("user/PermissionsList/");
  }

  GetUserIdByGuid(userGuid) {
    return this.GET("user/GetUserIdByGuid/" + userGuid);
  }

  Get1031AccessStatus(userId: number) {
    return this.GET("user/Get1031AccessStatus/" + userId);
  }

  GetUserRegistrationTrend(period) {
    return this.GET("user/userregistrationtrend/" + period);
  }

  GetUserBasicInfo(userGuid, userId) {
    return this.GET("user/GetUserBasicInfo/" + userGuid + "/" + userId);
  }

  Save1031Inquiry(userId) {
    return this.postForEntityObject("user/Save1031Inquiry", userId);
  }

  GenerateBRA(userId) {
    return this.postForEntityObject("user/GenerateBRA/", userId);
  }

  // Method to Check If User created by admin is signed Terms and Conditions
  CheckIfUserAcceptedTC(userId: number) {
    return this.get("user/CheckIfUserAcceptedTC/" + userId);
  }

  // Method to Check If User created by admin is signed Terms and Conditions
  CheckIfUserVerifiedAccount(userId: number) {
    return this.get("user/CheckIfUserVeified/" + userId);
  }

  CheckIfUserDeletedAccount(userId: number) {
    return this.get("user/CheckIfUserDeletedAccount/" + userId);
  }

  CheckIfDesHasProperty(userId: number) {
    return this.get("user/CheckIfDesHasProperty/" + userId);
  }

  CheckPendingBuyerQuestionnaire(userId: number) {
    return this.get("user/CheckPendingBuyerQuestionnaire/" + userId);
  }

  GetTermsandConditionDetails(): Observable<Date | null> {
    return this.get("user/GetTermsandConditionDetails");
  }

  CheckUserHasOpenedExchange(userId: number): Observable<boolean> {
    return this.get("user1031/checkUserHasOpenedExchange/" + userId);
  }


  AcceptTandC(userId) {
    return this.postForEntityObject("user/AcceptTandC/", userId);
  }

  GetYearlyCount(year): Observable<IuserCountYearly[]> {
    return this.get("user/getyearlycount/" + year);
  }

  GetMonthlyCount(year): Observable<IuserCountMonthly[]> {
    return this.get("user/getmonthlycount/" + year);
  }
  GetWeeklyCount(month, year): Observable<IuserCountWeekly[]> {
    return this.get("user/getweeklycount/" + month + "/" + year);
  }

  checkDuplicateUser(inputModel: any) {
    return this.postForEntityObject('user/UserInfo/', inputModel);
  }

  checkIsGuestUser(emailId) {
    return this.get('user/IsGuestUser/' + encodeURIComponent(emailId) + '/');
  }

  SaveInvitePrincipal(principalModal: any) {
    return this.postForEntityObject('user/principal/', principalModal);
  }

  SaveWatchList(watchListModel: any) {
    return this.postForEntityObject('user/AddToWatchList/', watchListModel);
  }

  RemoveWatchList(tenantId: number, loggedinUserId: number, userGuid: string) {
    return this.postForEntityObject('user/RemoveWatchList/' + tenantId + '/' + loggedinUserId + '/' + userGuid, '');
  }

  GetUserDetailsForMessage(userId) {
    return this.get("user/getUserDetails/" + userId);
  }

  AddToWaitList(userid: number) {
    return this.postForEntityObject('user/AddToWaitList/', userid);
  }

  EnableMyportfolio(userid: number) {
    return this.get("user/EnableMyportfolio/" + userid);
  }

  CheckIfUserAddedToWaitList(userId: number) {
    return this.get("user/CheckAddedToWaitList/" + userId);
  }

  CheckIfUserExists(inputModel: any) {
    let url = "/user/CheckUserExists/";
    return this.postForEntityObject<IResponseModel>(url, inputModel).pipe(
      map(response => {
        this.responseModel = response;
        return this.responseModel;
      }));
  }

  AddExistingUserAsStandardUser(inputModel: any) {
    return this.postForEntityObject('user/AddExistingUserAsStandardUser/', inputModel);
  }

 SaveUserRolePermissions(inputModel: any) {
    return this.postForEntityObject('user/saveRolePermissions/', inputModel);
  }

  GetStandardUserProperties(userId: number, userGuid: string) {
    let url = "/user/GetStandardUserProperties/" + userId + "/" + userGuid;
    return this.get<DataTablesResponse>(url).pipe(
      map(response => {
        this.standardUserProperties = response;
        return this.standardUserProperties;
      }));
  }

  DeleteStandardUser(standardUserId: number) {
    return this.GET('user/DeleteStandardUser/' + standardUserId);
  }

  GetInterestCriteriaDetails(userId: number) {
    return this.GET("user/GetInterestCriteriaDetails/" + userId);
  }

  SaveInterestCriteria(InterestCriteriaInputModel: IInterestCriteriaInputModel) {
    console.log(JSON.stringify(InterestCriteriaInputModel));
    let url = "user/SaveInterestCriteria/";
    return this.postForEntityObject(url, InterestCriteriaInputModel).pipe(
      map(response => {
        return response;
      }));
  }
  RequestDemo(RequestDemo: IRequestDemo) {
    debugger;
    let url = "user1031/RequestDemo/";
    return this.postForEntityObject(url, RequestDemo).pipe(
      map(response => {
        return response;
      }));
  }
}
